import { render } from "./form-input-template.vue?vue&type=template&id=bb079ca4&scoped=true"
import script from "./form-input-template.vue?vue&type=script&lang=js"
export * from "./form-input-template.vue?vue&type=script&lang=js"

import "./form-input-template.vue?vue&type=style&index=0&id=bb079ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb079ca4"]])

export default __exports__